import * as React from "react";

import { useContext, useEffect, useState } from "react";
import AuthService from "src/auth/auth-service";
import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import Logo from "../../resources/bart_logo.png";
import { InitDomain } from "src/context/domain/domainContext";
import { isProd } from "src/util";

export const FullPageHeader = () => {
  const [ldap, setLdap] = useState<string>("");
  const [given_name, setGiven_name] = useState<string>("");
  const [currentLocation, setCurrentLocation] = useState<string>("");
  const domainData = useContext(InitDomain);
  const authObj = new AuthService();
  const i18nStrings = {
    searchIconAriaLabel: "Search",
    searchDismissIconAriaLabel: "Close search",
    overflowMenuTriggerText: "More",
    overflowMenuTitleText: "All",
    overflowMenuBackIconAriaLabel: "Back",
    overflowMenuDismissIconAriaLabel: "Close menu",
  };
  useEffect(() => {
    const authen = async () => {
      await authObj.authenticate();
      setLdap(authObj.ldap);
      setGiven_name(authObj.given_name);
    };
    authen().catch(console.error);

    // Set current location
    setCurrentLocation(window.location.href);
  }, [domainData.domain]);

  // Helper function to check if current location matches any of the domain URLs
  const isCurrentDomain = (url: string): boolean => {
    return (
      currentLocation.startsWith(url) ||
      (url.includes("beta.bart-portal") &&
        currentLocation.startsWith("http://localhost"))
    );
  };

  // Helper function to get the current path and preserve it when switching domains
  const getDomainHrefWithCurrentPath = (baseDomainUrl: string): string => {
    try {
      const currentUrl = new URL(currentLocation);
      const currentPath =
        currentUrl.pathname + currentUrl.search + currentUrl.hash;

      // Remove trailing slash from base domain URL to avoid double slashes
      // e.g., 'https://domain.com/' + '/path' becomes 'https://domain.com/path'
      return baseDomainUrl.replace(/\/$/, "") + currentPath;
    } catch (error) {
      // Fallback to base domain URL if there's any error parsing the URL
      return baseDomainUrl;
    }
  };

  // Domain configuration
  const domains = [
    {
      id: "devo-FE",
      text: "Beta-FE",
      href: "https://beta.bart-portal.fuse.amazon.dev/",
    },
    {
      id: "prod-EU",
      text: "Prod-EU",
      href: "https://prod-eu.bart-portal.fuse.amazon.dev/",
    },
    {
      id: "prod-US",
      text: "Prod-US",
      href: "https://prod-us.bart-portal.fuse.amazon.dev/",
    },
    {
      id: "prod-FE",
      text: "Prod-JP",
      href: "https://prod-jp.bart-portal.fuse.amazon.dev/",
    },
  ];

  const supportActions = [
    {
      type: "menu-dropdown",
      id: "support-group",
      text: "Support",
      items: [
        {
          id: "Pascal",
          text: "Pascal Team",
          href: "https://w.amazon.com/bin/view/Fuse/Dev/Pascal/Team/",
          external: true,
          externalIconAriaLabel: " (opens in new tab)",
        },
        {
          text: "Feature Request / Bug",
          external: true,
          href: "https://t.corp.amazon.com/create/templates/c623e1ed-2587-431a-9e95-47f52ea7a8e7",
        },
      ],
    },
  ];

  const domainItems = domains.map((domain) => ({
    id: domain.id,
    text: isCurrentDomain(domain.href) ? (
      <div style={{ color: "#42b4ff", fontWeight: 1000 }}>{domain.text}</div>
    ) : (
      domain.text
    ),
    href: getDomainHrefWithCurrentPath(domain.href),
    external: false,
  }));

  const domainActions = [
    {
      type: "menu-dropdown",
      id: "Beta",
      text: "Beta",
      items: domainItems.filter((item) => item.id.startsWith("devo")),
    },
    {
      type: "menu-dropdown",
      id: "Prod",
      text: "Prod",
      items: domainItems.filter((item) => item.id.startsWith("prod")),
    },
  ];

  return (
    <TopNavigation
      i18nStrings={i18nStrings}
      identity={{
        href: "/",
        title: `BART Portal${!isProd() ? " (Beta)" : ""}`,
        logo: { src: Logo, alt: "Service name logo" },
      }}
      utilities={[
        {
          type: "menu-dropdown",
          text: `Hello ${given_name}`,
          description: ldap,
          iconName: "user-profile",
          items: [],
        },
        {
          type: "menu-dropdown",
          iconName: "support",
          items: supportActions,
        },
        {
          type: "menu-dropdown",
          text:
            domains.find((domain) => domain.id === domainData.domain)?.text ||
            domainData.domain,
          iconName: "globe",
          items: domainActions,
        },
      ]}
    />
  );
};
